import { BottomArrowSVG } from "src/assets/svg";
import { Drawer, Dropdown, Modal } from "antd";
import { GlobalOutlined } from "@ant-design/icons";
import { handleLogoutFunc } from "src/utils/index";
import { MainContext } from "src/context";
import { Link, useNavigate } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { ROLE, ROLE_T, TOKEN } from "src/static/const";
import { siteName } from "src/config/termConfig";
import { RatingWidget } from "src/components/RatingWidget";
import {
  profileMenuItems,
  profileTeacherMenuItems,
} from "src/static/data/menu_items";
import Login from "../login";
import ProfileButton from "../common/button/ProfileButton";
import { useTranslation, Language } from "src/i18n/context";
import { useUserStore } from "src/store/userStore";

function Header() {
  const navigate = useNavigate();
  const { profileOpen, setProfileOpen } = useContext(MainContext);
  const userInfo = useUserStore((state) => state.userInfo); // Zustand'dan userInfo'ni selector orqali olish
  const { language, setLanguage, t } = useTranslation();
  const [languageDropdownOpen, setLanguageDropdownOpen] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  
  const isUser = (() => {
    if (userInfo) return true;
    
    const role = localStorage.getItem(ROLE);
    const token = localStorage.getItem(TOKEN);
    return role === ROLE_T && !!token;
  })();

  const confirmFunc = () => {
    Modal.confirm({
      title: t("auth.logoutConfirm"),
      okText: t("common.yes"),
      cancelText: t("common.cancel"),
      onOk() {
        handleLogoutFunc();
      },
      onCancel() {
        Modal.destroyAll();
      },
    });
  };

  const menuItems = [
    {
      title: t("menu.quizzes"),
      icon: profileTeacherMenuItems[0]?.icon ?? profileMenuItems[0]?.icon,
      link: profileTeacherMenuItems[0]?.link ?? profileMenuItems[0]?.link,
    },
    {
      title: t("menu.personalInfo"),
      icon: profileTeacherMenuItems[1]?.icon ?? profileMenuItems[1]?.icon,
      link: profileTeacherMenuItems[1]?.link ?? profileMenuItems[1]?.link,
    },
  ];

  const menu = (
    <div className="kirgan__menu">
      {menuItems.map((item) => {
        return (
          <ProfileButton
            svg={item.icon}
            title={item.title}
            link={item.link}
            key={crypto?.randomUUID()}
          />
        );
      })}

      <button className="logout" onClick={confirmFunc}>
        {t("auth.logout")}
      </button>
    </div>
  );

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 860px)");
    const apply = () => setIsMobile(mq.matches);
    apply();
    const handler: any = () => apply();
    if (mq.addEventListener) mq.addEventListener("change", handler);
    else mq.addListener(handler);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener("change", handler);
      else mq.removeListener(handler);
    };
  }, []);

  const handleLanguageChange = (lang: Language) => {
    setLanguage(lang);
    setLanguageDropdownOpen(false);
    if (isMobile) setDrawerOpen(false);
  };

  const languageMenuItems = [
    {
      key: "uz",
      label: (
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <img src="https://flagcdn.com/w20/uz.png" alt="UZ" style={{ width: 20, height: 15, objectFit: "cover", borderRadius: 2 }} />
          <span>O'zbek</span>
          {language === "uz" && <span style={{ color: "#1890ff", marginLeft: "auto" }}>✓</span>}
        </div>
      ),
    },
    {
      key: "ru",
      label: (
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <img src="https://flagcdn.com/w20/ru.png" alt="RU" style={{ width: 20, height: 15, objectFit: "cover", borderRadius: 2 }} />
          <span>Русский</span>
          {language === "ru" && <span style={{ color: "#1890ff", marginLeft: "auto" }}>✓</span>}
        </div>
      ),
    },
    {
      key: "en",
      label: (
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <img src="https://flagcdn.com/w20/gb.png" alt="EN" style={{ width: 20, height: 15, objectFit: "cover", borderRadius: 2 }} />
          <span>English</span>
          {language === "en" && <span style={{ color: "#1890ff", marginLeft: "auto" }}>✓</span>}
        </div>
      ),
    },
    {
      key: "qr",
      label: (
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <img src="https://flagcdn.com/w20/uz.png" alt="QR" style={{ width: 20, height: 15, objectFit: "cover", borderRadius: 2 }} />
          <span>Qaraqalpaqsha</span>
          {language === "qr" && <span style={{ color: "#1890ff", marginLeft: "auto" }}>✓</span>}
        </div>
      ),
    },
  ];

  return (
    <>
    {/* Login modal - har doim mavjud bo'lishi uchun */}
    <Login modalOnly />
    
    {/* Header section */}
    <div className="header">
      <div className="container">
        {/* Logo side */}
        <div className="header__logos">
          <Link to="/" className="flex logo">
            <img src={require("src/assets/images/logo.png")} alt="HEMIS" />
            <span>{siteName}</span>
          </Link>
          {/* <div className="header__logo-divider" />
          <Link to="/" className="header__partner-logo">
            <img src="/umummilliy.png" alt="Umummilliy so'rovnoma" />
          </Link> */}
        </div>  

        {/* Navbar */}
        <div className="header__nav">
          {isMobile ? (
            <>
              <button
                type="button"
                className="header__burger"
                onClick={() => setDrawerOpen(true)}
                aria-label="Menu"
              >
                <span />
                <span />
                <span />
              </button>

              <Drawer
                open={drawerOpen}
                onClose={() => setDrawerOpen(false)}
                placement="right"
                width={320}
                title={null}
              >
                <div className="header__drawer">
                  <div className="header__drawer-section">
                    <div className="header__drawer-title">
                      <GlobalOutlined /> <span>Til / Язык</span>
                    </div>
                    <Dropdown
                      menu={{
                        items: languageMenuItems,
                        onClick: ({ key }) =>
                          handleLanguageChange(key as Language),
                      }}
                      trigger={["click"]}
                      placement="bottomRight"
                      open={languageDropdownOpen}
                      onOpenChange={setLanguageDropdownOpen}
                    >
                      <button type="button" className="header__langBtn">
                        <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
                          <img 
                            src={`https://flagcdn.com/w20/${language === "uz" || language === "qr" ? "uz" : language === "ru" ? "ru" : "gb"}.png`} 
                            alt="" 
                            style={{ width: 18, height: 13, objectFit: "cover", borderRadius: 2 }} 
                          />
                          {language === "uz" ? "O'zbek" : language === "ru" ? "Русский" : language === "en" ? "EN" : "Qaraqalpaqsha"}
                        </span>
                        <BottomArrowSVG />
                      </button>
                    </Dropdown>
                  </div>

                  <div className="header__drawer-section">
                    <div className="header__drawer-title">
                      <span>{t("common.profile")}</span>
                    </div>
                    {!isUser ? (
                      <div onClick={() => setDrawerOpen(false)}>
                        <Login />
                      </div>
                    ) : (
                      <>
                        {menuItems.map((item) => (
                          <button
                            key={item.link}
                            className="profile__tab flex"
                            onClick={() => {
                              navigate(item.link);
                              setDrawerOpen(false);
                            }}
                          >
                            {item.icon}
                            <span>{item.title}</span>
                          </button>
                        ))}
                        <button
                          className="logout"
                          onClick={() => {
                            setDrawerOpen(false);
                            confirmFunc();
                          }}
                        >
                          {t("auth.logout")}
                        </button>
                      </>
                    )}
                  </div>
                </div>
              </Drawer>
            </>
          ) : (
            <>
              {/* Language Switcher */}
              <Dropdown
                menu={{
                  items: languageMenuItems,
                  onClick: ({ key }) =>
                    handleLanguageChange(key as Language),
                }}
                trigger={["click"]}
                placement="bottomRight"
                open={languageDropdownOpen}
                onOpenChange={setLanguageDropdownOpen}
              >
                <button
                  type="button"
                  style={{
                    background: "transparent",
                    color: "#262626",
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    marginRight: 16,
                    border: "1px solid rgba(0, 0, 0, 0.15)",
                    borderRadius: 6,
                    padding: "4px 12px",
                    minWidth: 120,
                    justifyContent: "space-between",
                    cursor: "pointer",
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                  }}
                >
                  <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <img 
                      src={`https://flagcdn.com/w20/${language === "uz" || language === "qr" ? "uz" : language === "ru" ? "ru" : "gb"}.png`} 
                      alt="" 
                      style={{ width: 20, height: 15, objectFit: "cover", borderRadius: 2 }} 
                    />
                    <span style={{ fontSize: 14, fontWeight: 500 }}>
                      {language === "uz" ? "O'zbek" : language === "ru" ? "Русский" : language === "en" ? "EN" : "Qaraqalpaqsha"}
                    </span>
                  </span>
                  <BottomArrowSVG />
                </button>
              </Dropdown>

              {isUser && <RatingWidget />}

              {/* Profile section */}
              <div className="header__profile">
                {!isUser ? (
                  <Login />
                ) : (
                  <Dropdown
                    overlay={menu}
                    trigger={["click"]}
                    placement="bottomRight"
                    open={profileOpen}
                  >
                    <div className="kirgan" onClick={() => setProfileOpen?.(true)}>
                      <div className="kirgan__img">
                        {userInfo?.name ? `${userInfo?.name}` : "AA"}
                      </div>
                      <span>{t("common.profile")}</span>
                      <BottomArrowSVG />
                    </div>
                  </Dropdown>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
    </>
  );
}

export default Header;
